@if (!globals.isServer && !inNihul() && additionalContentComponent(); as additionalContent) {
    @if (additionalContentModule(); as additionalContentNgModule) {
        <ng-container *ngComponentOutlet="additionalContent; ngModule: additionalContentNgModule"></ng-container>
    }
}
@if (!globals.isServer && !inNihul() && chatbotComponent(); as chatbot) {
    <ng-container *ngComponentOutlet="chatbot"></ng-container>
}
<!-- the nihul is a work area: no site footer there at all (the component stays alive - its
     style imports and the chat/deferred-widget logic above keep working) -->
@if (!inNihul()) {
<footer class="main-footer relative resize-medium-center-desktop resize-footer-desktop">
    <shape-divider class="shape-footer" [isTop]="true" [shapeType]="shapeTypes.WavesOpacity" shapeWidth="175%"> </shape-divider>
    <section class="padding-main-container relative flex col gap32">
        <header class="flex a-center bet col gap24">
            <a class="logo-wrapper flex a-center col gap6" href="/">
                <yeshiva-logo></yeshiva-logo>
                <span i18n="@@yeshiva">ישיבה</span>
            </a>
        </header>
        <main class="grid bet a-start">
            @for (btnlinks of matLinks; track btnlinks; let i = $index) {
                <ul>
                    @for (btnLink of btnlinks; track btnLink; let j = $index) {
                        <li>
                            @if (btnLink.isAngularPage) {
                                <smart-router-link [link]="btnLink.link" [isRouterLink]="isAngularApp">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            contentLink;
                                            context: {
                                                btnLink: btnLink,
                                                isFirst: j === 0,
                                            }
                                        "
                                    >
                                    </ng-container>
                                </smart-router-link>
                            } @else {
                                <a [href]="btnLink.link">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            contentLink;
                                            context: {
                                                btnLink: btnLink,
                                                isFirst: j === 0,
                                            }
                                        "
                                    >
                                    </ng-container>
                                </a>
                            }
                        </li>
                    }
                    <!-- <a class="flex a-center gap6" *ngFor="let btnLink of btnlinks; let j=index" [href]="btnLink.link">
      <mat-icon *ngIf="btnLink.iconName">{{btnLink.iconName}}</mat-icon>
      <span [ngClass]="btnLink.className">
        {{btnLink.name}}
      </span>
    </a> -->
                </ul>
            }
            <ul>
                <li>
                    <a class="link-content first-child" href="/about">
                        <span i18n="@@betElYeshivaCenter">קרית הישיבה בית אל (ע"ר)</span>
                    </a>
                </li>
                @for (detail of yeahivaDetails; track detail) {
                    <li class="flex a-center gap6 link-content" [attr.title]="copyToClipboard" (click)="copyText(detail.value)">
                        <span class="mat-icon" aria-hidden="true">{{ detail.iconName }}</span>
                        {{ detail.name }}
                    </li>
                }
                <li [attr.title]="copyToClipboard" (click)="copyText('beitel@yeshiva.org.il')" class="flex a-center gap6 link-content">
                    <span class="mat-icon" aria-hidden="true">alternate_email</span>
                    <span i18n="@@email"
                        >דוא"ל<span>{{ ": " }}</span></span
                    >
                    <span [ngStyle]="{ 'text-transform': 'none' }" class="eng-letters">beitel&#64;yeshiva.org.il</span>
                </li>
            </ul>
            <ul class="share-icon-list flex gap16">
                <li>
                    <a aria-label="Facebook" href="https://www.facebook.com/yeshiva.org.il">
                        <img class="footer-social-icon icon-facebook" [src]="i18n.svgAssetsFullPathAutoLang('facebook.svg')" alt="" loading="lazy" width="32" height="32" />
                    </a>
                </li>
                <li>
                    <a aria-label="YouTube" href="https://www.youtube.com/user/yeshiva10">
                        <img class="footer-social-icon icon-youtube" [src]="i18n.svgAssetsFullPathAutoLang('youtube.svg')" alt="" loading="lazy" width="32" height="32" />
                    </a>
                </li>
                <li>
                    <a aria-label="WhatsApp" href="https://www.yeshiva.org.il/article/2946">
                        <img class="footer-social-icon icon-whatsapp" [src]="i18n.svgAssetsFullPathAutoLang('whatsapp.svg')" alt="" loading="lazy" width="32" height="32" />
                    </a>
                </li>
            </ul>
        </main>
        <!-- theme control (dark mode test phase) - client-only, see _updateThemeSwitch -->
        @if (!globals.isServer && showThemeSwitch()) {
            <theme-switch></theme-switch>
        }
        <span class="copyright" i18n="@@footercopyright">
            אנו משתדלים לאתר בעלי זכויות יוצרים, במידה ולא אותרו, נעשה שימוש ביצירה בהתאם לסעיף 27א לחוק זכויות יוצרים. אם אתם בעלי הזכויות ומעוניינים בהסרה או
            בקרדיט, אנא צרו קשר.
        </span>
        @if (copyFeedback()) {
            <span class="copy-feedback" role="status" aria-live="polite">{{ copyFeedback() }}</span>
        }
    </section>
</footer>
}

<ng-template #contentLink let-btnLink="btnLink" let-isFirst="isFirst">
    <span class="link-content flex a-center gap6" [ngClass]="{ 'first-child': isFirst }">
        @if (btnLink.iconName) {
            <span class="mat-icon" aria-hidden="true">{{ btnLink.iconName }}</span>
        }
        <span [ngClass]="btnLink.className">
            {{ btnLink.name }}
        </span>
    </span>
</ng-template>
